// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.semantic-view {
  min-height: 100vh;
  min-height: 100svh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.semantic-header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: var(--header-height);
  width: 100%;
  background-color: #f1f3f5;
  box-shadow: var(--cellula--elevation--skim);
  /* Needs to use a high z-index to have it appear on top of other elements */
  z-index: 2;
}
@media screen and (max-width: 700px) {
  .semantic-header.hide-on-small-devices {
    display: none;
  }
}

.semantic-main {
  position: relative;
  width: 100%;
  top: var(--header-height);
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-bottom: var(--header-height);
  overflow: hidden;
  background-color: var(--cellula--color--neutral--100);
  z-index: 1;
  min-height: calc(95vh - 48px);
}
@media screen and (max-width: 700px) {
  .semantic-main.full-screen {
    top: 0;
    margin: 0;
    min-height: 100%;
  }
}

.semantic-footer {
  width: 100%;
  overflow: hidden;
  min-height: 332px;
  background-color: var(--cellula--color--primary--300);
}
@media screen and (max-width: 700px) {
  .semantic-footer.hide-on-small-devices {
    display: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
